// extracted by mini-css-extract-plugin
module.exports = {"pageModule":"PageModules_pageModule__2VuWl","moduleWrap":"PageModules_moduleWrap__1gzRp","diffModule":"PageModules_diffModule__3CTKU"};